module.exports = __webpack_public_path__ + "img/new-reassign-downArrow.e2c1760b.svg";